import { ReactFlowProvider } from "@xyflow/react";
import VisualCanvasBoard from "./VisualCanvasBoard";

export default function VisualCanvasBoardWrapper() {
  return (
    <ReactFlowProvider>
      <VisualCanvasBoard />
    </ReactFlowProvider>
  );
}
